<div class="custom-width">
    <nav class="custom-breadcrumb" aria-label="breadcrumb">
        <ol class="breadcrumb gap-1 mb-0">
            <img [src]="commonImagePath+'home.webp'" alt="home-img" class="img-fluid home-icon pe-1" />
            <li class="breadcrumb-item d-flex flex-column">
                <a [routerLink]="[chTheme1 ? '/parts-and-accessories' : '/']" class="home-txt mb-0">Home</a>
            </li>
            
            <!--<li *ngIf="checkCategoryUrl()" class="breadcrumb-item">
                <a (click)="onClickMMY()" class="allcat-txt mb-0 cursor-pointer">All Categories</a>
            </li>-->
            <li class="breadcrumb-item" *ngFor="let item of breadcrumbData; let last = last" [class.active]="last">
                <ng-container *ngIf="!last; else lastItem">
                    <a (click)="onBreadcrumbClick(item)" class="cursor-pointer">
                        {{vehicle_name}} {{ item.name | removeBackslash}}
                    </a>
                </ng-container>
                <ng-template #lastItem>
                    <span class="name-subtitle">
                        <a (click)="onBreadcrumbClick(item)" class="cursor-pointer">
                            {{vehicle_name}} {{ item.name | removeBackslash}}
                        </a>
                    </span>
                </ng-template>
            </li>
        </ol>
    </nav>
</div>